<template>
  <div class="ma-6">
    <div class="maxh-4">
      <p>Clique no botão abaixo para desativar este dicionário CAN.</p>
      <p>O dicionário não será removido, apenas oculto da lista.</p>
      <p>
        Veículos que estavam associados com este dicionário continuarão
        embarcando as mesmas configurações de antes. Lembre-se de editar cada um
        para escolher um novo dicionário, caso necessário.
      </p>
      <OHoldToConfirm
        class="my-4"
        :large="true"
        color="error"
        label="Desativar"
        @confirmed="doDeactivate"
      />
    </div>
  </div>
</template>

<script>
import EditStore from './EditStore'
import OHoldToConfirm from 'oderon-vue/cpts/OHoldToConfirm.vue'

export default {
  tabTitle: 'Desativar',
  components: { OHoldToConfirm },
  methods: {
    async doDeactivate() {
      await EditStore.deactivate()
      this.$snack('Desativado com sucesso')

    }
  }
}
</script>

<style></style>
